import { render } from "./PagingView.vue?vue&type=template&id=0f7f7e74"
import script from "./PagingView.vue?vue&type=script&lang=js"
export * from "./PagingView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__